module.exports = __webpack_public_path__ + "img/tz8.168f4cef.png";